let platformPair = null;
let livePair = null;
let storedPair = null;
let generation = 0;

export function readDefaultPairGeneration() {
  return generation;
}

export function readPlatformPair() {
  return platformPair;
}

export function storePlatformPair(pair, expectedGeneration = generation) {
  if (expectedGeneration !== generation) return null;
  platformPair = pair;
  return pair;
}

export function readLiveDefaultPair() {
  return livePair;
}

export function storeLiveDefaultPair(pair, expectedGeneration = generation) {
  if (expectedGeneration !== generation) return null;
  livePair = pair;
  return pair;
}

export function readStoredDefaultPair() {
  return storedPair;
}

export function storeOfflineDefaultPair(pair) {
  storedPair = pair;
  return pair;
}

/** Drop every answer held for the previous identity without importing the resolution graph. */
export function resetDefaultPairState() {
  generation += 1;
  platformPair = null;
  livePair = null;
  storedPair = null;
}
